<app-loading *ngIf="carregando" cor="#e6e4e4" [colunas]="1" [linhas]="1" [height]="12.5"></app-loading>

<div style="position: relative">
  <app-info-popup class="ptr legenda-texto"
    [texto]="'COMPONENTS.LEGENDA_MAPA.description' | transloco"></app-info-popup>
  <div class="container-legendas" *ngIf="!operacaoId && tipoTaxa"><span class="label"><span
        class="etiqueta-azul etiqueta"></span>{{ "COMPONENTS.LEGENDA_MAPA.above_ideal" | transloco }} </span><br />
    <span class="label"><span
        class="etiqueta-verde etiqueta"></span>{{"COMPONENTS.LEGENDA_MAPA.between_median_and_ideal" | transloco}}
    </span><br />
    <span class="label"><span class="etiqueta-laranja-pastel etiqueta"></span>{{ "COMPONENTS.LEGENDA_MAPA.median" |
      transloco }} </span><br />
    <span class="label"><span
        class="etiqueta-laranja etiqueta"></span>{{"COMPONENTS.LEGENDA_MAPA.between_minimum_and_median" | transloco}}
    </span><br />
    <span class="label"><span class="etiqueta-vermelho etiqueta"></span>{{ "COMPONENTS.LEGENDA_MAPA.below_minimum" |
      transloco }} </span><br />
  </div>

  <ng-container *transloco="let t">
    <div class="container-legendas" *ngIf="tipoTaxa && !carregando && operacaoId">
      <span class="label">
        <span class="etiqueta-azul etiqueta"></span>
        {{ t("COMPONENTS.LEGENDA_MAPA.above_ideal_value", {
        ideal: legenda.ideal,
        unidade: tiposTaxaLegendas[tipo!],
        })
        }} </span><br />

      <span class="label">
        <span class="etiqueta-verde etiqueta"></span>
        {{ t("COMPONENTS.LEGENDA_MAPA.between_median_and_ideal_value", {
        mediana: legenda.mediana,
        ideal: legenda.ideal,
        unidade: tiposTaxaLegendas[tipo!],
        })
        }} </span><br />

      <span class="label">
        <span class="etiqueta-laranja-pastel etiqueta"></span>
        {{ t("COMPONENTS.LEGENDA_MAPA.median_value", {
        mediana: legenda.mediana,
        unidade: tiposTaxaLegendas[tipo!],
        })
        }} </span><br />

      <span class="label">
        <span class="etiqueta-laranja etiqueta"></span>
        {{ t("COMPONENTS.LEGENDA_MAPA.between_minimum_and_median_value", {
        minimo: legenda.minimo,
        mediana: legenda.mediana,
        unidade: tiposTaxaLegendas[tipo!],
        })
        }} </span><br />

      <span class="label"><span class="etiqueta-vermelho etiqueta"></span>
        {{ t("COMPONENTS.LEGENDA_MAPA.below_minimum_value", {
        minimo: legenda.minimo,
        unidade: tiposTaxaLegendas[tipo!],
        })
        }} </span><br />
    </div>
  </ng-container>

  <div class="container-legendas" *ngIf="tipo === 'rastros'">
    <h6 class="text-white">{{ "COMPONENTS.LEGENDA_MAPA.routes_title" | transloco }}</h6>
    <ng-container *ngIf="camadas$ | async as camadas">
      <span class="label" *ngIf="camadas.planting_track"><span class="etiqueta-verde-plantio etiqueta"></span>{{
        "COMPONENTS.LEGENDA_MAPA.planting" |
        transloco }} </span>
      <span class="label" *ngIf="camadas.maneuvering_track"><span class="etiqueta-vermelho-plantio etiqueta"></span>{{
        "COMPONENTS.LEGENDA_MAPA.maneuver" |
        transloco }} </span>
      <span class="label" *ngIf="camadas.displacement_track"><span class="etiqueta-azul-plantio etiqueta"></span>{{
        "COMPONENTS.LEGENDA_MAPA.displacement" |
        transloco }} </span>
      <span class="label" *ngIf="camadas.stops"><span
          class="etiqueta-parada-justificada etiqueta etiqueta-quadrado"></span>{{
        "COMPONENTS.LEGENDA_MAPA.stop_justified" | transloco }} </span>
      <span class="label" *ngIf="camadas.stops"><span
          class="etiqueta-parada-nao-justificada etiqueta etiqueta-quadrado"></span>{{
        "COMPONENTS.LEGENDA_MAPA.stop_not_justified" | transloco }} </span>
    </ng-container>
  </div>

  <div class="container-legendas" *ngIf="tipo === 'falhas'">
    <h6 class="text-white">{{ "COMPONENTS.LEGENDA_MAPA.failures_title" | transloco }}</h6>
    <span class="label"><span class="etiqueta-roxa-falhas etiqueta"></span>{{ "COMPONENTS.LEGENDA_MAPA.planting_failure"
      | transloco }} </span>
    <span class="label"><span class="etiqueta-verde-falhas etiqueta"></span>{{
      "COMPONENTS.LEGENDA_MAPA.replanted_failure" | transloco }} </span><br />
  </div>

  <div class="container-legendas legenda-velocidade" *ngIf="tipo === 'velocidade'">
    <h6 class="text-white">{{ "COMPONENTS.LEGENDA_MAPA.velocidade_title" | transloco }}</h6>
    <ng-container *ngIf="velocidadeIdeal$ | async as velocidadeIdeal">
      <span class="label">
        <span class="etiqueta" [style.background-color]="velocidadeIdeal.vc_cor_abaixo_minimo"></span>
        {{ "COMPONENTS.LEGENDA_MAPA.velocidade_abaixo_minimo" | transloco }} (&lt; {{ velocidadeIdeal.fl_minimo }} km/h)
      </span>
      <span class="label">
        <span class="etiqueta" [style.background-color]="velocidadeIdeal.vc_cor_ideal"></span>
        {{ "COMPONENTS.LEGENDA_MAPA.velocidade_ideal" | transloco }} ({{ velocidadeIdeal.fl_minimo }}–{{
        velocidadeIdeal.fl_maximo }} km/h)
      </span>
      <span class="label">
        <span class="etiqueta" [style.background-color]="velocidadeIdeal.vc_cor_acima_maximo"></span>
        {{ "COMPONENTS.LEGENDA_MAPA.velocidade_acima_maximo" | transloco }} (&gt; {{ velocidadeIdeal.fl_maximo }} km/h)
      </span>
    </ng-container>
  </div>
</div>